// =============================================================================
// D86 — app-shell geometry.
//
// These numbers were hardcoded in `apps/web/src/app/chrome/primitives.tsx` and
// then COPIED into `apps/platform-admin/src/shell/chrome.ts` when D90 put the
// console on the product shell. The copy was deliberate and carried its reason,
// because D86 had already recorded the geometry as untokenised: "when it is
// tokenised there are now exactly two obvious call sites, not one plus a
// lookalike." This module is that tokenisation, and those are those call sites.
//
// Two copies of a number that must agree is a drift waiting to happen — the
// rail is the one piece of chrome both apps must render identically, since it
// is what makes them read as one product.
//
// Geometry only. The sidebar's COLOURS are `sidebar` in `tokens/color.ts`, which
// is mode-aware; none of these values change between light and dark.
// =============================================================================

/** The rail. Always present — it says WHICH workspace you are in. */
const railWidth = 64;

/** The panel beside it. Lists the pages inside the current workspace. */
const panelWidth = 208;

export const chrome = {
  railWidth,
  panelWidth,

  /**
   * Total width of expanded chrome.
   *
   * DERIVED, never written down twice: 64 + 208 = 272, which is exactly the
   * single column the rail/panel split replaced, so no page reflowed when
   * WS-RAIL landed. Deriving it means the invariant cannot be broken by
   * editing one number — a rail that quietly grows is how the product's own
   * IA problem started, and the equality is asserted in both shells' specs.
   */
  expandedWidth: railWidth + panelWidth,

  /**
   * Header band shared by rail and panel, so the mark and the workspace name
   * share one baseline. 56 replaced a 72px brand box that held a 24px lockup
   * and read as a gap, because nothing else on the surface was spaced that way.
   */
  headerHeight: 56,

  /** A rail button. */
  rowHeight: 40,

  /** A page row in the panel. */
  leafHeight: 32,

  /** mobile_strategy §2.4 — minimum touch target on phones. */
  touchRowHeight: 48,

  /**
   * The mobile top bar. Equal to `headerHeight` by coincidence of measurement
   * rather than by rule, so it is its own key: they are different bands on
   * different surfaces and either may move without the other.
   */
  mobileBarHeight: 56,
} as const;

export type ChromeTokens = typeof chrome;
